<template>
  <div class="app-dailog text-box-wrapper"
    v-if="!removed"
    :class="{show: shouldShow, closing: closeInProcess}"
    @click="onContainerClick">

    <div class="dailog-content full-width" @click="onBoxClick">
      <div class="cancel" v-if="showCancel" @click="onCancel">
        <img src="@/assets/imgs/close.svg">
      </div>
      <div class="head-box">
        <div class="main">
          <h3 v-if="property == 'code'">Add Code</h3><h3 v-else>Add Description</h3>
          <el-input
            type="textarea"
            :rows="5"
            :placeholder="property == 'code' ? 'Add your ' + property : 'Add your Description'"
            v-model="payload[property]">
          </el-input>
        </div>
        <div class="buttons">
          <button class="create-btn fullcolor" @click="onYes">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    showTitle: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    payload: Object,
    show: {
      type: Boolean,
      default: false
    },
    property: null
  },
  data () {
    return {
      closeInProcess: false,
      shouldShow: false,
      removed: true,
      timeoutId: null
    }
  },
  watch: {
    'show' (toShow, from) {
      if (toShow && !this.shouldShow) {
        this.doShow()
      } else if (!toShow && this.shouldShow) {
        this.doClose()
      }
    }
  },
  mounted () {
    if (this.show && !this.shouldShow) {
      this.doShow()
    }
  },

  methods: {
    doClose () {
      this.shouldShow = false
      this.closeInProcess = true
      this.$emit('onClosing', this.payload)

      this.timeoutId = setTimeout(() => {
        this.closeInProcess = false
        this.removed = true
        this.$emit('onClose', this.payload, false)
      }, 300)
    },

    doShow () {
      if (this.closeInProcess) {
        clearTimeout(this.timeoutId)
        this.closeInProcess = true
      }
      this.removed = false
      setTimeout(() => {
        this.shouldShow = true
      }, 50)
    },

    onCancel () {
      this.$emit('onCancel', this.payload)
      this.doClose()
    },

    onYes () {
      this.$emit('onYes', this.payload)
      this.doClose()
    },

    onBoxClick (event) {
      event.stopPropagation()
    },

    onContainerClick (event) {
      this.onCancel()
    }
  }
}
</script>
